import axiosInterseptor from '../../utils/axiosInterseptor';
import { adaptPhotos } from '../../utils/catalogUtils';

export default class ReviewData {
  static async getAll() {
    const response = await fetch(`/reviewData.json`);
    const data = await response.json();
    return data;
  }

  static async getCollectionReviews() {
    try {
      const response = await axiosInterseptor.get(`products/reviews/scored`);
      let { data } = response;
      if (data && Array.isArray(data)) {
        data = data.map((item: any) => ({
          ...item,
          photos: adaptPhotos(
            item.photos.photos,
            { photos_url: item.photos.url, photos_res: item.photos.res },
            item.product_id,
          ),
        }));
      }
      return data;
    } catch (error) {
      console.error('Error:', error);
      return error;
    }
  }

  static async getCollectionReviewsDateFilter(filter: string, page: number, signal: AbortSignal) {
    try {
      const response = await axiosInterseptor.get(
        `products/reviews/${filter}?mode=search&page=${page}`,
        {
          signal,
        },
      );
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }
}
